import { request } from '@src/library/API';
import { GetTokenParamType, InitDataType } from '@src/types/mainType';

export const CallGetInit = () => request<InitDataType>({ url: '/biz/init', method: 'get' });

export const CallGetToken = (data: GetTokenParamType) => request({ url: '/token', method: 'get', host: 'auth', data });
